// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportEnrollRenterInCreditTrackingHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentCreditReportEnrollCreditTrackingWebApiRequestDto } from '../..';

export const RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking_Path =
  '/api/web/v1/rentCreditReport/enrollRenterInCreditTracking';

/**
 * Enroll renter in credit tracking
 */
export const RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking = (
  postData: RentCreditReportEnrollCreditTrackingWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentCreditReportEnrollCreditTrackingWebApiRequestDto, void>(
    {
      endpoint: RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
